import { render, staticRenderFns } from "./PublishBanner.vue?vue&type=template&id=6587f711&scoped=true&"
import script from "./PublishBanner.vue?vue&type=script&lang=ts&"
export * from "./PublishBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PublishBanner.vue?vue&type=style&index=0&id=6587f711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587f711",
  null
  
)

export default component.exports